import { Link, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import Header from "../../components/partials/Header";
import Footer from "../../components/partials/Footer";



const About = () => {
    const navigate = useNavigate(); // Initialize the navigate function

    return (
        <>
            <div id="hero" style={{ backgroundImage: 'unset', height: '100px' }}>
                <Header page={'about'} />
            </div>
            
            <div className="home_about inner_about">
                <div className="ha_title">
                    <h2>ჩვენ შესახებ</h2>
                </div>
                <div className="ha_wrapper">
                    <div className="ha_info">
                        <p>
                            Sky hook Georgia უკვე წლებია რაც წარმატებით ოპერირებს ქართულ ბაზარზე და მომხმარებელს სთავაზობს უსაფრთხო მშენებლობისთვის საჭირო სხვადასხვა ლითონის კონსტრუქციებს: 
                        </p>
                        <ul>
                            <li className="fw-900">საყალიბე სისტემები</li>
                            <li className="fw-900">შიდა და საფასადე, გარე ხარაჩოები</li>
                            <li className="fw-900">მიმღები ბაქნები</li>
                            <li className="fw-900">შახტაში ასაწყობი ხარაჩოები</li>
                            <li className="fw-900">უსაფრთხოების რეგულირებად & ფიქსირებულ მოაჯირები</li>
                            <li className="fw-900">ნებისმიერი ტიპის მეტალის კონსტრუქციები (კარი, ჭიშკარი და სხვა)</li>
                        </ul>
                        <p> 
                            ლითონ კონსტრუქცია <span className="fw-900">დამზადებულია საქართველოში და აკმაყოფილებს ყველა სახელმწიფო  და ევრო სტანდარტს</span> ხარაჩოების და ყალიბების წარმოებისთვის, რეალიზაციისა და ექსპორტისთვის. 
                            №477 27.10.2017
                            №361 27.05.2014
                        </p>
                    </div>
                    <div className="ha_cers">
                        <img src="/images/certs.png" alt="" />
                    </div>
                    <div className="about_contact">
                        <div className="ac_title">
                            <p>საკონტაქტო ინფორმაცია:</p>

                            <a href="#">
                                <img src="/images/marker.png" alt="" />
                                თბილისი, რქაწითელის ქ. 21
                            </a>
                            <a href="mailto:INFO@SKYHOOK.GE">
                                <img src="/images/email.png" alt="" />
                                INFO@SKYHOOK.GE
                            </a>
                            <a href="tel:032157090">
                                <img src="/images/phone.png" alt="" />
                                032 157 090
                            </a>
                            <a href="whatsapp:+995598666022">
                                <img src="/images/whatsapp.png" alt="" />
                                598 666 022
                            </a>
                        </div>
                    </div>
                    <div className="about_social">
                        <p>გამოგვყევით:</p>
                        <div className="ac_links">
                            <a href="https://www.facebook.com/@SkyHookGeorgia/" target="_blank"><img src="/images/fb_blue.png" alt="" /></a>
                            <a href="https://www.instagram.com/skyhookgeorgia/" target="_blank"><img src="/images/instagram_blue.png" alt="" /></a>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

        </>
    )
}
  
export default About